import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';

import Flow from 'flow';
import { prettyFormatE164Number } from 'flow/utils/call-utils';
import { getCountryCode } from 'flow/utils/extension-utils';
import { showCallDialog } from 'flow/actions/call-dialog-actions';
import { getOwnContact } from 'flow/selectors/selectors';
import NumberWrapper from 'flow/components/ui-components/NumberWrapper';
import CallAdaptiveButton from 'flow/components/CallAdaptiveButton';

const ContactNumberField = (props) => {
    const {
        userCountryCode,
        contact_info_type,
        contact_info_value,
        extensionKey,
        contactToCall,
        inactiveBgColor,
    } = props;

    const hiddenButtonDiv = useRef(null);
    const handleCall = (event) => {
        event.stopPropagation();
        if (hiddenButtonDiv)
            hiddenButtonDiv.current.querySelector('button').click();
    };

    if (contact_info_value) {
        const prettyNumber = prettyFormatE164Number(
            contact_info_value,
            userCountryCode,
        );

        return (
            <div
                className={`group mx-4 flex grow cursor-pointer flex-wrap items-center justify-between rounded-sm p-2 ${inactiveBgColor ? 'hover:darken-10' : 'hover:bg-gray-200'} md:flex-row`}
                onClick={handleCall}
            >
                <div className="whitespace-nowrap text-gray-800">
                    {contact_info_type}
                </div>
                <div className="group-hover:text-link text-end text-sm text-gray-500">
                    <NumberWrapper>{prettyNumber}</NumberWrapper>
                </div>
                <div ref={hiddenButtonDiv} className="hidden">
                    <CallAdaptiveButton
                        phoneNumber={contact_info_value}
                        extensionKey={extensionKey}
                        transferContact={contactToCall}
                        bgColor={'bg-gray-200'}
                    />
                </div>
            </div>
        );
    } else {
        return null;
    }
};

ContactNumberField.propTypes = {
    contact_info_type: PropTypes.string.isRequired,
    contact_info_value: PropTypes.string,
    userCountryCode: PropTypes.string,
    extensionKey: Flow.PropTypes.extensionKey,
    contactToCall: PropTypes.instanceOf(Map),
    inactiveBgColor: PropTypes.bool,
};

const mapStateToProps = (state) => {
    const contact = getOwnContact(state);
    const userCountryCode = getCountryCode(contact);

    return { userCountryCode };
};

const mapDispatchToProps = (dispatch) => ({
    onClick: (number, extensionToCall, extraCallOptions) =>
        dispatch(showCallDialog(number, extensionToCall, extraCallOptions)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactNumberField);
